export default __webpack_public_path__ + "static/media/check.3f9c6d1d.png";